import { render } from "./password-card.vue?vue&type=template&id=3901c171"
import script from "./password-card.vue?vue&type=script&lang=js"
export * from "./password-card.vue?vue&type=script&lang=js"

import "./password-card.vue?vue&type=style&index=0&id=3901c171&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__